/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Company,
  LeadSource,
  LeadSourceRequest,
  ModeratorCompanyDetailsRequest,
  ModeratorCompanySetTagsRequest,
  ModeratorsCompaniesApproveCreateBody,
  ModeratorsCompaniesCompanyInformationRetrieve200,
  ModeratorsCompaniesComplianceCreateBody,
  ModeratorsCompaniesFlagCreateBody,
  ModeratorsCompaniesListParams,
  ModeratorsCompaniesRetrieve200,
  ModeratorsCompaniesSourceBreakdownRetrieve200,
  ModeratorsLeadSourcesListParams,
  ModeratorsTagsListParams,
  PaginatedLeadSource,
  PaginatedModeratorCompany,
  PaginatedModeratorTag,
  PatchedLeadSourceRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all companies with optional search by name and filters by tag, country, and region. All filters are optional. Paginated.
 * @summary List companies (moderator)
 */
export const moderatorsCompaniesList = (
    params?: ModeratorsCompaniesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorCompany[]>(
      {url: `/api/v1/moderators/companies/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsCompaniesListQueryKey = (params?: ModeratorsCompaniesListParams,) => {
    return [`/api/v1/moderators/companies/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsCompaniesListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCompaniesList>>, TError = void>(params?: ModeratorsCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCompaniesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCompaniesList>>> = ({ signal }) => moderatorsCompaniesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCompaniesListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesList>>>
export type ModeratorsCompaniesListQueryError = void

/**
 * @summary List companies (moderator)
 */
export const useModeratorsCompaniesList = <TData = Awaited<ReturnType<typeof moderatorsCompaniesList>>, TError = void>(
 params?: ModeratorsCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCompaniesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Full company record plus its sub-resources (entity registrations, shareholders, documents) — everything a moderator needs to review the company in one request.
 * @summary Get company detail (moderator)
 */
export const moderatorsCompaniesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorsCompaniesRetrieve200>(
      {url: `/api/v1/moderators/companies/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCompaniesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/companies/${id}/`] as const;
    }

    
export const getModeratorsCompaniesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCompaniesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>> = ({ signal }) => moderatorsCompaniesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCompaniesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>>
export type ModeratorsCompaniesRetrieveQueryError = void

/**
 * @summary Get company detail (moderator)
 */
export const useModeratorsCompaniesRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCompaniesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Approve a company and either provision its first owner user (initial approval) or rotate the existing owner's password (re-activation after a flag). The owner is emailed the password. Idempotent — calling this on an already-active approved company is a no-op.
 * @summary Approve a company (moderator)
 */
export const moderatorsCompaniesApproveCreate = (
    id: number,
    moderatorsCompaniesApproveCreateBody: ModeratorsCompaniesApproveCreateBody,
 ) => {
      
      
      return customInstance<Company>(
      {url: `/api/v1/moderators/companies/${id}/approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorsCompaniesApproveCreateBody
    },
      );
    }
  


export const getModeratorsCompaniesApproveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>, TError,{id: number;data: ModeratorsCompaniesApproveCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>, TError,{id: number;data: ModeratorsCompaniesApproveCreateBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>, {id: number;data: ModeratorsCompaniesApproveCreateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCompaniesApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCompaniesApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>>
    export type ModeratorsCompaniesApproveCreateMutationBody = ModeratorsCompaniesApproveCreateBody
    export type ModeratorsCompaniesApproveCreateMutationError = void

    /**
 * @summary Approve a company (moderator)
 */
export const useModeratorsCompaniesApproveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>, TError,{id: number;data: ModeratorsCompaniesApproveCreateBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCompaniesApproveCreate>>,
        TError,
        {id: number;data: ModeratorsCompaniesApproveCreateBody},
        TContext
      > => {

      const mutationOptions = getModeratorsCompaniesApproveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update the admin-managed compliance fields on a company: overall status/score and the three tier scores. All fields optional; send null on a score to mark it not assessed.
 * @summary Set company compliance (moderator)
 */
export const moderatorsCompaniesComplianceCreate = (
    id: number,
    moderatorsCompaniesComplianceCreateBody: ModeratorsCompaniesComplianceCreateBody,
 ) => {
      
      
      return customInstance<Company>(
      {url: `/api/v1/moderators/companies/${id}/compliance/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorsCompaniesComplianceCreateBody
    },
      );
    }
  


export const getModeratorsCompaniesComplianceCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>, TError,{id: number;data: ModeratorsCompaniesComplianceCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>, TError,{id: number;data: ModeratorsCompaniesComplianceCreateBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>, {id: number;data: ModeratorsCompaniesComplianceCreateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCompaniesComplianceCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCompaniesComplianceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>>
    export type ModeratorsCompaniesComplianceCreateMutationBody = ModeratorsCompaniesComplianceCreateBody
    export type ModeratorsCompaniesComplianceCreateMutationError = void

    /**
 * @summary Set company compliance (moderator)
 */
export const useModeratorsCompaniesComplianceCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>, TError,{id: number;data: ModeratorsCompaniesComplianceCreateBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCompaniesComplianceCreate>>,
        TError,
        {id: number;data: ModeratorsCompaniesComplianceCreateBody},
        TContext
      > => {

      const mutationOptions = getModeratorsCompaniesComplianceCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Edit a company's identity fields: name, industry, description, country (ISO 3166-1 alpha-2), region, and trade-corridor label. Email is intentionally not editable here — it's the company's login identity.
 * @summary Update company info (moderator)
 */
export const moderatorsCompaniesDetailsCreate = (
    id: number,
    moderatorCompanyDetailsRequest: ModeratorCompanyDetailsRequest,
 ) => {
      
      
      return customInstance<Company>(
      {url: `/api/v1/moderators/companies/${id}/details/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorCompanyDetailsRequest
    },
      );
    }
  


export const getModeratorsCompaniesDetailsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>, TError,{id: number;data: ModeratorCompanyDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>, TError,{id: number;data: ModeratorCompanyDetailsRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>, {id: number;data: ModeratorCompanyDetailsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCompaniesDetailsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCompaniesDetailsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>>
    export type ModeratorsCompaniesDetailsCreateMutationBody = ModeratorCompanyDetailsRequest
    export type ModeratorsCompaniesDetailsCreateMutationError = void

    /**
 * @summary Update company info (moderator)
 */
export const useModeratorsCompaniesDetailsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>, TError,{id: number;data: ModeratorCompanyDetailsRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCompaniesDetailsCreate>>,
        TError,
        {id: number;data: ModeratorCompanyDetailsRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCompaniesDetailsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deactivate an already-approved company. Inverse of approve. Pre-approval companies should stay pending — use this to flag an active company for review.
 * @summary Flag a company (moderator)
 */
export const moderatorsCompaniesFlagCreate = (
    id: number,
    moderatorsCompaniesFlagCreateBody: ModeratorsCompaniesFlagCreateBody,
 ) => {
      
      
      return customInstance<Company>(
      {url: `/api/v1/moderators/companies/${id}/flag/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorsCompaniesFlagCreateBody
    },
      );
    }
  


export const getModeratorsCompaniesFlagCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>, TError,{id: number;data: ModeratorsCompaniesFlagCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>, TError,{id: number;data: ModeratorsCompaniesFlagCreateBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>, {id: number;data: ModeratorsCompaniesFlagCreateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCompaniesFlagCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCompaniesFlagCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>>
    export type ModeratorsCompaniesFlagCreateMutationBody = ModeratorsCompaniesFlagCreateBody
    export type ModeratorsCompaniesFlagCreateMutationError = void

    /**
 * @summary Flag a company (moderator)
 */
export const useModeratorsCompaniesFlagCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>, TError,{id: number;data: ModeratorsCompaniesFlagCreateBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCompaniesFlagCreate>>,
        TError,
        {id: number;data: ModeratorsCompaniesFlagCreateBody},
        TContext
      > => {

      const mutationOptions = getModeratorsCompaniesFlagCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Set the list of tags for a company. Tags must exist in the system (create them in admin; list via GET /api/v1/moderators/tags/).
 * @summary Set company tags
 */
export const moderatorsCompaniesSetTagsCreate = (
    id: number,
    moderatorCompanySetTagsRequest: ModeratorCompanySetTagsRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/companies/${id}/setTags/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorCompanySetTagsRequest
    },
      );
    }
  


export const getModeratorsCompaniesSetTagsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>, TError,{id: number;data: ModeratorCompanySetTagsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>, TError,{id: number;data: ModeratorCompanySetTagsRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>, {id: number;data: ModeratorCompanySetTagsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCompaniesSetTagsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCompaniesSetTagsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>>
    export type ModeratorsCompaniesSetTagsCreateMutationBody = ModeratorCompanySetTagsRequest
    export type ModeratorsCompaniesSetTagsCreateMutationError = unknown

    /**
 * @summary Set company tags
 */
export const useModeratorsCompaniesSetTagsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>, TError,{id: number;data: ModeratorCompanySetTagsRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCompaniesSetTagsCreate>>,
        TError,
        {id: number;data: ModeratorCompanySetTagsRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCompaniesSetTagsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns company counts: total, verified (KYB verdict `verified`: an awarded badge proving registry and screening), pending (awaiting approval), and flagged (inactive, cancelled, or disabled). Available to all moderators.
 * @summary Company information (moderator / super moderator)
 */
export const moderatorsCompaniesCompanyInformationRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorsCompaniesCompanyInformationRetrieve200>(
      {url: `/api/v1/moderators/companies/companyInformation/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCompaniesCompanyInformationRetrieveQueryKey = () => {
    return [`/api/v1/moderators/companies/companyInformation/`] as const;
    }

    
export const getModeratorsCompaniesCompanyInformationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCompaniesCompanyInformationRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>> = ({ signal }) => moderatorsCompaniesCompanyInformationRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCompaniesCompanyInformationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>>
export type ModeratorsCompaniesCompanyInformationRetrieveQueryError = void

/**
 * @summary Company information (moderator / super moderator)
 */
export const useModeratorsCompaniesCompanyInformationRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesCompanyInformationRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCompaniesCompanyInformationRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Where companies came from (WP1.9). `byType` counts each source type plus `unknown` (companies registered before sources were recorded). `bySource` counts each named source (inactive ones included), plus `unlisted` (a type was chosen with free text only) and `unknown`; its counts add up to `total`. Readable by every moderator.
 * @summary Company counts by lead source (moderator)
 */
export const moderatorsCompaniesSourceBreakdownRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorsCompaniesSourceBreakdownRetrieve200>(
      {url: `/api/v1/moderators/companies/sourceBreakdown/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCompaniesSourceBreakdownRetrieveQueryKey = () => {
    return [`/api/v1/moderators/companies/sourceBreakdown/`] as const;
    }

    
export const getModeratorsCompaniesSourceBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCompaniesSourceBreakdownRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>> = ({ signal }) => moderatorsCompaniesSourceBreakdownRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCompaniesSourceBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>>
export type ModeratorsCompaniesSourceBreakdownRetrieveQueryError = unknown

/**
 * @summary Company counts by lead source (moderator)
 */
export const useModeratorsCompaniesSourceBreakdownRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCompaniesSourceBreakdownRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCompaniesSourceBreakdownRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * All named lead sources, active and inactive, with how many companies chose each. Any moderator. Paginated.
 * @summary List lead sources
 */
export const moderatorsLeadSourcesList = (
    params?: ModeratorsLeadSourcesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedLeadSource[]>(
      {url: `/api/v1/moderators/lead-sources/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsLeadSourcesListQueryKey = (params?: ModeratorsLeadSourcesListParams,) => {
    return [`/api/v1/moderators/lead-sources/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsLeadSourcesListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsLeadSourcesList>>, TError = unknown>(params?: ModeratorsLeadSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsLeadSourcesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsLeadSourcesList>>> = ({ signal }) => moderatorsLeadSourcesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsLeadSourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsLeadSourcesList>>>
export type ModeratorsLeadSourcesListQueryError = unknown

/**
 * @summary List lead sources
 */
export const useModeratorsLeadSourcesList = <TData = Awaited<ReturnType<typeof moderatorsLeadSourcesList>>, TError = unknown>(
 params?: ModeratorsLeadSourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsLeadSourcesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderator only. Type is institution, event or partner.
 * @summary Create lead source
 */
export const moderatorsLeadSourcesCreate = (
    leadSourceRequest: LeadSourceRequest,
 ) => {
      
      
      return customInstance<LeadSource>(
      {url: `/api/v1/moderators/lead-sources/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leadSourceRequest
    },
      );
    }
  


export const getModeratorsLeadSourcesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>, TError,{data: LeadSourceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>, TError,{data: LeadSourceRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>, {data: LeadSourceRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsLeadSourcesCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsLeadSourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>>
    export type ModeratorsLeadSourcesCreateMutationBody = LeadSourceRequest
    export type ModeratorsLeadSourcesCreateMutationError = void

    /**
 * @summary Create lead source
 */
export const useModeratorsLeadSourcesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>, TError,{data: LeadSourceRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsLeadSourcesCreate>>,
        TError,
        {data: LeadSourceRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsLeadSourcesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Rename, retype, activate or deactivate. Super moderator only.
 * @summary Update lead source
 */
export const moderatorsLeadSourcesPartialUpdate = (
    id: number,
    patchedLeadSourceRequest: PatchedLeadSourceRequest,
 ) => {
      
      
      return customInstance<LeadSource>(
      {url: `/api/v1/moderators/lead-sources/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLeadSourceRequest
    },
      );
    }
  


export const getModeratorsLeadSourcesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>, TError,{id: number;data: PatchedLeadSourceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>, TError,{id: number;data: PatchedLeadSourceRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>, {id: number;data: PatchedLeadSourceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsLeadSourcesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsLeadSourcesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>>
    export type ModeratorsLeadSourcesPartialUpdateMutationBody = PatchedLeadSourceRequest
    export type ModeratorsLeadSourcesPartialUpdateMutationError = void

    /**
 * @summary Update lead source
 */
export const useModeratorsLeadSourcesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>, TError,{id: number;data: PatchedLeadSourceRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsLeadSourcesPartialUpdate>>,
        TError,
        {id: number;data: PatchedLeadSourceRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsLeadSourcesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Super moderator only. Refused (400) when companies already recorded this source — deactivate it instead.
 * @summary Delete lead source
 */
export const moderatorsLeadSourcesDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/lead-sources/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsLeadSourcesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsLeadSourcesDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsLeadSourcesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>>
    
    export type ModeratorsLeadSourcesDestroyMutationError = void

    /**
 * @summary Delete lead source
 */
export const useModeratorsLeadSourcesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsLeadSourcesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsLeadSourcesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List all tags available in the system. Tags are created in the admin panel; moderators use them to assign to companies. Paginated.
 * @summary List tags
 */
export const moderatorsTagsList = (
    params?: ModeratorsTagsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorTag[]>(
      {url: `/api/v1/moderators/tags/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsTagsListQueryKey = (params?: ModeratorsTagsListParams,) => {
    return [`/api/v1/moderators/tags/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsTagsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsTagsList>>, TError = unknown>(params?: ModeratorsTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsTagsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsTagsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsTagsList>>> = ({ signal }) => moderatorsTagsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsTagsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsTagsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsTagsList>>>
export type ModeratorsTagsListQueryError = unknown

/**
 * @summary List tags
 */
export const useModeratorsTagsList = <TData = Awaited<ReturnType<typeof moderatorsTagsList>>, TError = unknown>(
 params?: ModeratorsTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsTagsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsTagsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



